import CheckMark from "../../assets/check-mark.png";
import "./styles/plan-select.css";

const PLANS = [
  {
    id: "couples_essentials",
    title: "Essentials",
    price: 10,
    accessPeriod: "1 Month Access:",
    accessList: ["1 Location", "1 Date"],
    features: ["Temperature","Humidity","Wind","Clouds","Precipitation","Sunrise/Sunset"],
  },
  {
    id: "couples_standard",
    title: "Standard",
    price: 50,
    accessPeriod: "3 Month Access:",
    accessList: ["1 Location","Any Date","Monthly Updates"],
    features: ["Temperature","Humidity","Wind","Clouds","Precipitation","Sunrise/Sunset"],
  },
  {
    id: "couples_premium",
    title: "Premium",
    price: 100,
    accessPeriod: "6 Month Access:",
    accessList: ["Any Location","Any Date","Monthly Updates"],
    features: ["Temperature","Humidity","Wind","Clouds","Precipitation","Sunrise/Sunset"],
  }
];

export default function PlanSelectStep({ selected, onSelect, onBack, onNext }) {
  return (
    <section className="step plan-select fade-in">
      <h2>Select a plan to gift</h2>

      <div className="plans-row">
        {PLANS.map(p => (
          <article
            key={p.id}
            className={`plan-card ${selected === p.id ? "selected" : ""}`}
            onClick={() => onSelect(p.id)}
          >
            <h3 className="plan-title">{p.title}</h3>
            <p className="price">${p.price}</p>

            <div className="access-details">
              <p className="access-period">{p.accessPeriod}</p>
              <ul className="access-list">
                {p.accessList.map(li => <li key={li}>{li}</li>)}
              </ul>
            </div>

            <div className="card-divider" />

            <ul className="features-list">
              {p.features.map(f => (
                <li key={f}><img src={CheckMark} alt="" /> {f}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className="plan-actions">
        <button className="secondary-btn" onClick={onBack}>Back</button>
        <button className="primary-btn" disabled={!selected} onClick={onNext}>
          Continue →
        </button>
      </div>
    </section>
  );
}
